// Constants.
// -----------------------------------------------------------------------------
export const SKELETON_DEFAULT_ANIMATION = 'wave';
export const SKELETON_DEFAULT_BORDER_RADIUS = '8px';
export const SKELETON_DEFAULT_RADIUS = 48;
export const SKELETON_DEFAULT_HEIGHT = '1.5rem';
export const SKELETON_DEFAULT_VARIANT = 'rectangular';
export const SKELETON_DEFAULT_WIDTH = '100%';
//# sourceMappingURL=Skeleton.constants.js.map